// 正式
module.exports = {
    title: '生产',
    baseUrl: 'xxx', // 正式项目地址
    baseApi: 'https://gateway.hatelifu.club', // 正式api请求地址
    APPID: 'xxx',
    APPSECRET: 'xxx',
    $cdn: 'xxx'
}